module.exports = __webpack_public_path__ + "static/img/m3_t4a_edge.8c893a52.jpg";